module.exports = __webpack_public_path__ + "static/pac-d7b644e9ce0afde1d1bb46d38d84e04a.svg";